<div class="row col-12 p-0 m-0 main-page-section">
    <div class="col-12 p-0 companies-section">
        <div class="col-height">
            <div>
                <div class="breadcrumbs-section padding-left">
                    <span class="prev-page pt-1 "><a routerLink="/overview">Home</a></span>
                    <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
                    <span class="prev-page"><a routerLink="/meeting-room/view-meeting-room">Meeting Room List</a></span>
                </div>
            </div>

            <div class="place-layout" *ngIf="isLoaded">

                <h2>Meeting Room List</h2>
                <div class="row">
                    <div class="col-12">
                        <hr class="hr1">
                    </div>
                </div>

                <div class="row">
                    <div class="col-2"><input type="radio" [checked]="true" style="display: none;" id="act" value="act"
                            name="typ" (click)="selectType($event)"><label [ngClass]="type=='act'?'checked':'check'"
                            for="act">Active</label>
                    </div>
                    <div class="col-3"><input type="radio" style="display: none;" id="main" value="main" name="typ"
                            (click)="selectType($event)"><label [ngClass]="type=='main'?'checked':'check'"
                            for="main">Under Maintenance</label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-10" style="position: inherit; margin-top: -35px;">
                        <hr class="hr2">
                    </div>
                    <div class="col-2"></div>
                </div>


                <div class="row" *ngIf="actProp">
                    <div class="addProperty mr-3 col-3" *ngIf="meetingRoomCreate || meetingRoomEdit">
                        <button (click)="selectedFacility()"><img class="pr-1 pb-1"
                                src="../../../assets/images/add.png"> Add New Meeting Room</button>
                    </div>


                    <div *ngFor="let item of MeetingRoomList;let i=index" class="col-3 mr-3 mb-5 building-saved h-auto">
                        <div *ngIf="item.roomName" style="cursor: pointer;">
                            <img src="{{item.meetingRoomImageUrl}}" (click)="goToDetailsPage(item.parkMeetingRoomId)">
                            <div class="building-entry row align-items-center py-3">
                                <div class="col-10" (click)="goToDetailsPage(item.parkMeetingRoomId)">
                                    <p class="building-name mb-0">{{item.roomName}}</p>
                                    <p class="building-name mb-0">Capacity : {{item.capacity}} pax</p>
                                    <div class="_amenities_wrap">
                                        <!-- *ngFor="let listaminities of item?.meetingAmenityResponseList; let i=index;" -->
                                        <ng-template ngFor let-listaminities
                                            [ngForOf]="item?.meetingAmenityResponseList" let-i="index">
                                            <img class="_icon" src={{listaminities.imageURL}}
                                                [alt]="listaminities.amenityName" />
                                        </ng-template>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="list-option pl-4" (clickOutside)="onClickedOutside($event)"
                                        [autoClose]="'outside'" [ngbPopover]="popContent2" triggers="manual"
                                        #p2="ngbPopover" (click)="$event.stopPropagation();openPopover(p2)"
                                        placement="bottom" *ngIf="meetingRoomEdit || meetingRoomRemove">
                                        <div class="dot"></div>
                                        <div class="dot"></div>
                                        <div class="dot"></div>
                                        <ng-template #popContent2>
                                            <div>
                                                <div class="popover-content" style="cursor: pointer;"
                                                    (click)="$event.stopPropagation();openPopover(p2);openModal(item.parkMeetingRoomId, item.roomName)"
                                                    *ngIf="meetingRoomRemove">Delete</div>
                                                <div class="popover-content" style="cursor: pointer;"
                                                    (click)="$event.stopPropagation();openPopover(p2);navigateToEdit(item.parkMeetingRoomId)"
                                                    *ngIf="meetingRoomEdit">Under Maintenance</div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- <div *ngIf="MeetingRoomList.length<=0">
                    <div class="row" *ngIf="actProp">
                        <div class="addProperty mr-5 col-3">
                            <button (click)="selectedFacility()"><img class="pr-1 pb-1"
                                    src="../../../assets/images/add.png"> Add new Meeting Room</button>
                        </div>
                    </div>
                </div> -->

                <div *ngIf="!underMaintainance">
                    <empty-state *ngIf="MeetingRoomList.length==0"></empty-state>
                </div>

                <div *ngIf="underMaintainance">
                    <div *ngIf="MeetingRoomListUnderMaintaince.length>0">
                        <div class="row">
                            <div class="col-3 mr-3 mb-5 building-saved h-auto"
                                *ngFor="let item of MeetingRoomListUnderMaintaince;let i=index">
                                <div *ngIf="item.roomName">
                                    <img src="{{item.meetingRoomImageUrl}}"
                                        (click)="goToDetailsPage(item.parkMeetingRoomId)">
                                    <div class="building-entry row align-items-center py-3">
                                        <div class="col-10" (click)="goToDetailsPage(item.parkMeetingRoomId)">
                                            <p class="building-name mb-0">{{item.roomName}}</p>
                                            <p class="building-name mb-0">Capacity : {{item.capacity}} pax</p>
                                            <div class="_amenities_wrap">
                                                <!-- *ngFor="let listaminities of item?.meetingAmenityResponseList; let i=index;" -->
                                                <ng-template ngFor let-listaminities
                                                    [ngForOf]="item?.meetingAmenityResponseList" let-i="index">
                                                    <img class="_icon" src={{listaminities.imageURL}}
                                                        [alt]="listaminities.amenityName" />
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <div class="list-option pl-4" (clickOutside)="onClickedOutside($event)"
                                                [autoClose]="'outside'" [ngbPopover]="popContent1" triggers="manual"
                                                #p1="ngbPopover" (click)="$event.stopPropagation();openPopover(p1)"
                                                placement="bottom">
                                                <div class="dot"></div>
                                                <div class="dot"></div>
                                                <div class="dot"></div>
                                                <ng-template #popContent1>
                                                    <div>
                                                        <div class="popover-content" style="cursor: pointer;"
                                                            (click)="$event.stopPropagation();openPopover(p1);openModal(item.parkMeetingRoomId, item.roomName)">
                                                            Delete</div>
                                                        <!-- <div class="popover-content" style="cursor: pointer;"
                                                        (click)="$event.stopPropagation();openPopover(p1);navigateToEdit(item.parkMeetingRoomId)">
                                                        Under Maintenance
                                                    </div> -->
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <!-- <span class="building-name col-10 mt-3" *ngIf="item.isPaid === false">Free</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <empty-state *ngIf="MeetingRoomListUnderMaintaince.length==0"></empty-state>
                </div>

                <ng-template #contentActivation let-modal class="text-center">
                    <div class="modal-height">
                        <div class="modal-body">
                            <div class="">
                                <div class="text pt-3 pb-3">Are you sure, you want to Delete?</div>
                                <div class="popup-line"></div>
                            </div>
                        </div>
                        <div class="submit col-12 d-flex justify-content-end ">
                            <div class="pr-3">
                                <button type="button " class="cancel-button pt-3"
                                    (click)="modal.close('Save click')"><span class="cancel">Cancel</span></button>
                            </div>
                            <button type="button " class="add-button" (click)="modal.close('Save click')"
                                (click)="DeleteMeetingRoom()"><span class="add">Delete</span></button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>